module.exports = __webpack_public_path__ + "static/img/didi.8ddcc80.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/didi.png
// module id = 3SR7
// module chunks = 4